<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6">
        <div class="card mb-4">
          <div class="card-header">
            <h5 class="mb-0">Crear nuevo Link</h5>
          </div>
          <div class="card-body">
            <form @submit.prevent="saveLink">
              <div class="mb-3">
                <label class="form-label">Nombre</label>
                <input v-model="form.name" class="form-control" required />
              </div>
              <div class="mb-3">
                <label class="form-label">Modelo destino</label>
                <select v-model="form.modelName" class="form-select" required>
                  <option value="" disabled>Selecciona un modelo</option>
                  <option
                    v-for="model in models"
                    :key="model.modelName"
                    :value="model.modelName"
                  >
                    {{ model.label || model.modelName }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-label">Descripción</label>
                <input v-model="form.description" class="form-control" />
              </div>
              <div class="mb-3">
                <label class="form-label">Sección</label>
                <select v-model="form.section" class="form-select" required>
                  <option value="view_content">View content</option>
                  <option value="edit_content">Edit content</option>
                  <option value="list_content">List content</option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-label">URL (usa shortcodes)</label>
                <input
                  v-model="form.urlTemplate"
                  class="form-control"
                  required
                  placeholder="https://pepe/contact/{model->_id}"
                />
                <small class="form-text text-muted">
                  Puedes usar <code>{model->_id}</code> o cualquier campo del
                  modelo destino.<br />
                  Ejemplo: <code>https://pepe/contact/{model->_id}</code>
                </small>
              </div>
              <div class="mb-3">
                <label class="form-label">Visibilidad por cliente</label>
                <input
                  v-model="form.clientVisibility"
                  class="form-control"
                  placeholder="cliente1, cliente2, cliente3"
                />
                <small class="form-text text-muted">
                  Subdominios separados por coma. Si se deja vacío, el link se
                  mostrará a todos los clientes.
                </small>
              </div>
              <div class="mb-3">
                <label class="form-label">Vista previa del link</label>
                <div class="alert alert-secondary">
                  {{ previewUrl }}
                </div>
              </div>
              <button class="btn btn-primary" type="submit">
                {{ form._id ? "Actualizar" : "Crear" }}
              </button>
              <button
                v-if="form._id"
                class="btn btn-secondary ms-2"
                @click.prevent="resetForm"
              >
                Cancelar
              </button>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5 class="mb-0">Links existentes</h5>
          </div>
          <div class="card-body p-0">
            <table class="table table-hover mb-0">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Modelo</th>
                  <th>Sección</th>
                  <th>URL</th>
                  <th>Clientes</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="link in links" :key="link._id">
                  <td>{{ link.name }}</td>
                  <td>{{ link.modelName }}</td>
                  <td>{{ formatSection(link.section) }}</td>
                  <td>
                    <code>{{ link.urlTemplate }}</code>
                  </td>
                  <td>
                    <span v-if="link.clientVisibility" class="badge bg-info">
                      {{ link.clientVisibility }}
                    </span>
                    <span v-else class="text-muted">Todos</span>
                  </td>
                  <td>
                    <button
                      class="btn btn-sm btn-outline-primary me-1"
                      @click="editLink(link)"
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-outline-danger"
                      @click="deleteLink(link)"
                    >
                      <i class="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="links.length === 0">
                  <td colspan="6" class="text-center">
                    No hay links creados aún.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { wencesApi } from "@/api/wencesApi";

export default {
  name: "AdminLinks",
  data() {
    return {
      models: [],
      links: [],
      form: {
        name: "",
        urlTemplate: "",
        modelName: "",
        description: "",
        section: "view_content",
        clientVisibility: "",
      },
      previewUrl: "",
    };
  },
  watch: {
    "form.urlTemplate": "updatePreview",
    "form.modelName": "updatePreview",
  },
  created() {
    this.fetchModels();
    this.fetchLinks();
  },
  methods: {
    async fetchModels() {
      const res = await wencesApi.get("/api/gotrading/model-definitions");
      this.models = res.data;
    },
    async fetchLinks() {
      // Use raw=true to get all links without clientVisibility filter
      const res = await wencesApi.get("/api/admin-links?raw=true");
      this.links = res.data;
    },
    async saveLink() {
      if (this.form._id) {
        await wencesApi.put(`/api/admin-links/${this.form._id}`, this.form);
      } else {
        await wencesApi.post("/api/admin-links", this.form);
      }
      this.fetchLinks();
      this.resetForm();
    },
    editLink(link) {
      this.form = { ...link };
      this.updatePreview();
    },
    async deleteLink(link) {
      if (confirm("¿Seguro que deseas eliminar este link?")) {
        await wencesApi.delete(`/api/admin-links/${link._id}`);
        this.fetchLinks();
        if (this.form._id === link._id) this.resetForm();
      }
    },
    resetForm() {
      this.form = {
        name: "",
        urlTemplate: "",
        modelName: "",
        description: "",
        section: "view_content",
        clientVisibility: "",
      };
      this.previewUrl = "";
    },
    updatePreview() {
      if (!this.form.urlTemplate || !this.form.modelName) {
        this.previewUrl = "";
        return;
      }
      // Simulación simple: reemplaza {model->_id} por 12345
      this.previewUrl = this.form.urlTemplate.replace(
        /\{model->([\w_]+)\}/g,
        (m, field) => {
          if (field === "_id") return "12345";
          return field.toUpperCase();
        }
      );
    },
    formatSection(section) {
      const sections = {
        view_content: "View content",
        edit_content: "Edit content",
        list_content: "List content",
      };
      return sections[section] || section;
    },
  },
};
</script>

<style scoped>
.card {
  min-height: 350px;
}
.table td,
.table th {
  vertical-align: middle;
}
</style>
